import React, { useCallback, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import slugify from "slugify";

import { Button, Form, Input, Modal, Space, Card, Row, Col } from "antd";

import { AiFillCheckCircle, AiFillCloseSquare } from "react-icons/ai";

import modulesApi from "../api/module/modulesApi";
import Swal from "sweetalert2";
import { CheckNullParams } from "../utils/CheckNullParams";
import { useDispatch, useSelector } from "react-redux";
import { fileManagerActions } from "../store";
import UploadFile from "../components/UploadFile";
import { BackwardFilled, BackwardOutlined } from "@ant-design/icons";

const dataExample = {
  companyName: null,
  legal: null,
  address: null,
  email: null,
  hotline: null,
  phoneNumber: null,
  customerCarePhoneNumber: null,
  talkTo: null,
  facebookMessenger: null,
  dcma: null,
  bct: null,
  linkFacebook: null,
  linkZalo: null,
  linkYoutube: null,
  linkTiktok: null,
  linkInstagram: null,
};

const Info = (props) => {
  const dispatch = useDispatch();

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };
  const { TextArea } = Input;
  const [valueFormData, setValueFormData] = useState(dataExample);

  const confirm = Modal.confirm;
  const [form] = Form.useForm();

  useEffect(() => {
    getWebSettings();
  }, [form]);

  const [loading, setLoading] = useState(false);

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  const getWebSettings = () => {
    setLoading(true);
    modulesApi
      .getWebSettings()
      .then((res) => {
        if (res?.values !== null) {
          const data = res?.values;
          console.log(data);
          setImageNull(res?.values?.logo);
          form.setFieldsValue(data);
        } else {
          setImageNull(null);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const updateSettings = (item) => {
    setLoading(true);
    const object = {
      logo: fileImageUrl,
      companyName: item.companyName,
      legal: item.legal,
      address: item.address,
      email: item.email,
      hotline: item.hotline,
      hotline2: item.hotline2,
      phoneNumber: item.phoneNumber,
      customerCarePhoneNumber: item.customerCarePhoneNumber,
      talkTo: item.talkTo,
      facebookMessenger: item.facebookMessenger,
      dcma: item.dcma,
      bct: item.bct,
      linkFacebook: item.linkFacebook,
      linkZalo: item.linkZalo,
      linkYoutube: item.linkYoutube,
      linkTiktok: item.linkTiktok,
      linkInstagram: item.linkInstagram,
    };
    const data = CheckNullParams(object);

    const payload = {
      "web-settings": data,
    };

    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thông tin thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getWebSettings();
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <>
      <Card
        extra={
          <>
            <Space>
              <Button
                type="primary"
                icon={<AiFillCheckCircle />}
                onClick={() => {
                  form.submit();
                }}
              >
                &nbsp;Lưu
              </Button>
              <Button
                icon={<BackwardFilled />}
                onClick={() => {
                  goToPreviousPath();
                }}
              >
                &nbsp;Quay lại
              </Button>
            </Space>
          </>
        }
      >
        <div>
          <br />
          <Form
            form={form}
            initialValues={valueFormData}
            onFinish={updateSettings}
            onFinishFailed={onFinishFailed}
            labelCol={{
              span: 7,
            }}
            layout="horizontal"
            size="large"
          >
            <Row gutter={[24, 0]}>
              <Col span={8}>
                <Form.Item label="Logo">
                  <UploadFile />
                </Form.Item>
              </Col>
              {/* 
              <Col span={8}>
                <Form.Item label="Logo chân trang">
                  <UploadFileProp
                    // onUploadMb={onUploadMb}
                    // image={bannerMb}
                    type="second"
                  />
                </Form.Item>
                -
              </Col> */}
            </Row>

            <Row gutter={[24, 0]}>
              <Col span={8}>
                <Form.Item label="Tên công ty" name="companyName">
                  <Input />
                </Form.Item>
                <Form.Item label="Pháp lý" name="legal">
                  <Input />
                </Form.Item>
                <Form.Item label="Địa chỉ" name="address">
                  <Input />
                </Form.Item>
                <Form.Item label="Số điện thoại" name="phoneNumber">
                  <Input />
                </Form.Item>
                <Form.Item label="Email" name="email">
                  <Input />
                </Form.Item>
                <Form.Item label="Đường dây nóng" name="hotline">
                  <Input />
                </Form.Item>
                <Form.Item label="Đường dây nóng 2" name="hotline2">
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Số chăm sóc KH"
                  name="customerCarePhoneNumber"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Mã nhúng Talk.to" name="talkTo">
                  <TextArea rows={3} />
                </Form.Item>
                <Form.Item label="Mã nhúng Messenger" name="facebookMessenger">
                  <TextArea rows={3} />
                </Form.Item>
                <Form.Item label="Mã nhúng DCMA" name="dcma">
                  <TextArea rows={3} />
                </Form.Item>
                <Form.Item label="Mã nhúng BCT" name="bct">
                  <TextArea rows={3} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Link Facebook" name="linkFacebook">
                  <Input />
                </Form.Item>
                <Form.Item label="Link Zalo" name="linkZalo">
                  <Input />
                </Form.Item>
                <Form.Item label="Link Youtube" name="linkYoutube">
                  <Input />
                </Form.Item>
                <Form.Item label="Link Tiktok" name="linkTiktok">
                  <Input />
                </Form.Item>
                <Form.Item label="Link Instagram" name="linkInstagram">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Card>
    </>
  );
};

export default Info;
